export default function initSales() {
    bindSalesExpand();
    bindCouponsModal();
}

function bindSalesExpand() {
    for (const toggle of document.querySelectorAll('.sales-toggle')) {
        toggle.addEventListener('click', (e) => {

            if (!e.target.classList.contains('prevent-expand')) {
                const parent = toggle.parentNode.parentNode;
                const content = parent.nextElementSibling.nextElementSibling;

                if (parent.classList.contains('expanded')) {
                    content.classList.remove('show');
                    parent.classList.remove('expanded');
                } else {
                    content.classList.add('show');
                    parent.classList.add('expanded');

                    if (window.innerWidth <= 768) {
                        content.scrollIntoView({
                            behavior: 'auto',
                            block: 'center',
                            inline: 'center'
                        });
                    }
                }
            }
        });
    }
}

let currentCouponClicked = null;

function bindCouponsModal() {
    const couponModal = document.getElementById('send-coupon');
    const couponModalButtons = document.querySelectorAll('.open-coupon-send-btn');

    if (couponModal) {
        for (const couponSendButton of couponModalButtons) {
            couponSendButton.addEventListener('click', async (e) => {
                e.preventDefault();
                const code = couponSendButton.getAttribute('data-code');

                if (code) {
                    couponModal.querySelector('input[name=code]').value = code;
                    currentCouponClicked = couponSendButton;
                }
            })
        }
    }
}

export function processCouponSendResponse(form, action) {
    const messageNode = document.createElement('span');
    messageNode.classList.add('general-success');
    messageNode.innerHTML = action[1];
    form.appendChild(messageNode);
    form.classList.remove('loading');
    messageNode.classList.add('p-0');

    for (const el of form.querySelectorAll('.axios-hide')) {
        el.classList.add('d-none');
    }

    for (const el of form.querySelectorAll('.axios-clear')) {
        el.value = '';
    }

    if (currentCouponClicked) {
        currentCouponClicked.innerHTML = action[2];
        currentCouponClicked.classList.add('prevent-modal');
    }
}
